<ng-select (typed)="fetchUsersByKeyword($event)"
           (selected)="selectUser($event)"
           (checked)="onChecked($event)"
           [customEmptyText]="customEmptyText"
           [items]="userList"
           [active]="activeSelection"
           [isMultiSelect]="isMultiSelect"
           [placeholder]="placeholder"
           [asyncAutoCompletion]="true"
           class="form-control h-33">
</ng-select>
<i *ngIf="isEmployeesLoading" class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
